/* Package JSON Import will be here */
import { forEach } from "lodash";
/* Package JSON Import will be here */

/* Override the default properties with config properties - Language English */
export const enOverride = () => {
    let enObject = require("./en.json");

    forEach(window.enOverride, (o) => {
        enObject[o.key] = o.value
    });

    return enObject;
};

/* Override the default properties with config properties - Language German */
export const deOverride = () => {
    let deObject = require("./de.json");

    forEach(window.deOverride, (o) => {
        deObject[o.key] = o.value
    });

    return deObject;
};

/* Override the default properties with config properties - Language Spanish*/
export const esOverride = () => {
    let esObject = require("./es.json");

    forEach(window.esOverride, (o) => {
        esObject[o.key] = o.value
    });

    return esObject;
};